export enum EnumPlanStatusType {
    NotInit = 'NOT_INIT',
    Studing = 'STUDING',
    Studied = 'STUDIED',
    Removed = 'REMOVED'
}